/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Team_TitleInputs */

const en_landing_team_title = /** @type {(inputs: Landing_Team_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your coaches.`)
};

const pl_landing_team_title = /** @type {(inputs: Landing_Team_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoi trenerzy.`)
};

/**
* | output |
* | --- |
* | "Your coaches." |
*
* @param {Landing_Team_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_team_title = /** @type {((inputs?: Landing_Team_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Team_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_team_title(inputs)
	return en_landing_team_title(inputs)
});